(function(){
  var svc = document.getElementById('services');
  if(!svc) return;
  var list = svc.querySelector('.svc-list');
  var thread = svc.querySelector('.svc-thread');
  if(!list || !thread) return;
  var rows = Array.prototype.slice.call(list.querySelectorAll('.svc-row'));
  var nodes = Array.prototype.slice.call(thread.querySelectorAll('.svc-node'));
  var t0 = 0, tlen = 1, thresholds = [];
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function measure(){
    var lb = list.getBoundingClientRect();
    var centers = rows.map(function(r){ var rb = r.getBoundingClientRect(); return (rb.top - lb.top) + rb.height / 2; });
    if(!centers.length) return;
    t0 = centers[0];
    tlen = Math.max(1, centers[centers.length - 1] - t0);
    thread.style.setProperty('--t0', t0 + 'px');
    thread.style.setProperty('--tlen', tlen + 'px');
    nodes.forEach(function(n, i){ if(centers[i] != null) n.style.top = centers[i] + 'px'; });
    thresholds = centers.map(function(c){ return (c - t0) / tlen; });
  }
  function updThread(){
    var lb = list.getBoundingClientRect();
    var firstAbs = lb.top + t0, span = tlen;
    var draw = (window.innerHeight * 0.55 - firstAbs) / span;
    draw = Math.max(0, Math.min(1, draw));
    thread.style.setProperty('--svc-draw', draw.toFixed(3));
    nodes.forEach(function(n, i){ n.classList.toggle('active', draw >= Math.max(thresholds[i], 0.03)); });
  }
  measure();
  if(reduce){
    thread.style.setProperty('--svc-draw', '1');
    nodes.forEach(function(n){ n.classList.add('active'); });
    return;
  }
  updThread();
  window.addEventListener('scroll', function(){ requestAnimationFrame(updThread); }, { passive: true });
  window.addEventListener('resize', function(){ measure(); updThread(); });
  window.addEventListener('load', function(){ measure(); updThread(); });
})();
